import { FC, ReactNode } from 'react'
import { useIsYandexCountry } from '../hooks/useIsYandexCountry'

export const AdvertisingByCountry: FC<{
  adsense: ReactNode
  yandex: ReactNode
}> = ({ yandex, adsense }) => {
  const isYandexCountry = useIsYandexCountry()

  if (isYandexCountry === null) {
    return null
  }

  return isYandexCountry ? yandex : adsense
}
